
import React from 'react';
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Plus, Pencil, X } from "lucide-react";
import { BridgeDataItem } from './types';
import { getIconComponent } from './utils/iconUtils';

interface BridgeComponentsSectionProps {
  bridgeData: BridgeDataItem[];
  onAddClick: () => void;
  onEditClick: (item: BridgeDataItem) => void;
  onDeleteClick: (item: BridgeDataItem) => void;
}

export const BridgeComponentsSection: React.FC<BridgeComponentsSectionProps> = ({
  bridgeData,
  onAddClick,
  onEditClick,
  onDeleteClick
}) => {
  return (
    <div className="my-4 rounded mx-0 px-[13px] py-[10px] bg-secondary/80 p-4 border border-primary/20">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-primary font-semibold text-sm">Revenue Bridge Components</h3>
        <Button onClick={onAddClick} className="h-[35px] rounded-default font-normal px-[10px] text-[14px] text-black bg-primary rounded-md py-[21px]">
          <Plus size={14} className="mr-1" /> Add Bridge Item
        </Button>
      </div>
      <Separator className="mb-3 bg-primary-DEFAULT" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {bridgeData.filter(item => !item.isStart && !item.isTarget && !item.isTotalBridged && item.name !== "Order to Revenue Conversion Rate").map((item, index) => (
          <Card key={index} className="bg-secondary-dark/20 border-primary-dark p-3 relative bg-gray-900">
            <div className="absolute top-1 right-1 flex space-x-1">
              <button className="text-gray-400 hover:text-primary transition-colors" onClick={() => onEditClick(item)}>
                <Pencil size={16} />
              </button>
              <button className="text-gray-400 hover:text-red-500 transition-colors" onClick={() => onDeleteClick(item)}>
                <X size={16} />
              </button>
            </div>
            
            <div className="flex items-center gap-2 mt-2">
              <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{
                backgroundColor: item.fill
              }}>
                {getIconComponent(item.iconName)}
              </div>
              <span className="text-primary text-[14px] ml-1">{item.name}</span>
              <span className={`ml-auto text-[13px] ${item.value >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                {item.displayValue}
              </span>
            </div>
            <div className="mt-2">
              <p className="text-primary-light text-[11px] w-full text-left">{item.description}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
